import { Button, dialog } from "nq-component";
import BaseFormPresenter from "../../../../../components/common/BaseFormPresenter";
import {
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import { createNotification } from "../../../../../createNotification";

class MonetizationApproverFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }
  DialogConfirmation(status) {
    dialog.fire({
      html: (
        <div className="p-2">
          <div className="row">
            <h4>{status}</h4>
            <hr />
            <p style={{ fontSize: "13px", padding: "1rem" }}>
              Click Confirm to continue!
            </p>
            <hr />
          </div>
          <div className="w-100 d-flex justify-content-end gap-4 pe-3 pb-3">
            <Button
              className="btn btn-light fs-sm"
              onClick={() => dialog.close()}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              onClick={async () => {
                this.submitData(status);
              }}
            >
              Confirm
            </Button>
          </div>
        </div>
      ),
      footer: false,
    });
  }

  async submitData(status) {
    const { stats, selectedType, employee, acl, ...rest } =
      this.view.state.object;

    const submitData = {
      stats: "For HRMS Processing",
      selectedType: this.view.state.selectedType,
      id: this.view.getObjectId(),
      employee: { id: employee.id },
      ...rest,
    };

    // const leave_cred = await findObjectUseCase().execute("leave_cred", {
    //   where: { empID: submitData.employee.id, type: selectedType },
    // });
    // console.log("LEAVE: ", leave_cred[0].current);

    // if (status === "Disapproved") {
    //   await upsertUseCase().execute("monetization_request", submitData);
    //   dialog.close();
    //   this.showSuccess("Successfully Disapproved");
    //   const NOTIFICATION_MESSAGE =
    //     "Your Monetization Request has been rejected!";
    //   const NOTIFICATION_RECEIVER = [submitData.employee.id];
    //   const NOTIFICATION_REDIRECT = "lmanagement";

    //   createNotification(
    //     NOTIFICATION_MESSAGE,
    //     NOTIFICATION_RECEIVER,
    //     NOTIFICATION_REDIRECT
    //   );
    //   return;
    // }

    // if (
    //   leave_cred.length > 0 &&
    //   parseFloat(leave_cred[0].current) >= submitData.inputCredit
    // ) {
    //   const newCurrent = leave_cred.reduce((accumulator, _) => {
    //     return accumulator - submitData.inputCredit;
    //   }, leave_cred[0].current);

    //   const deduction = parseFloat(newCurrent).toFixed(3).toString();
    //   const { current, ...updateLeaveCred } = leave_cred[0];
    //   const updateData = {
    //     current: deduction,
    //     ...updateLeaveCred,
    //   };
    await upsertUseCase().execute("monetization_request", submitData);
    // if (status === "Approved") {
    //   await upsertUseCase().execute("leave_cred", updateData);
    // }
    dialog.close();
    this.showSuccess("Successfully Approved");
    const NOTIFICATION_MESSAGE = "Your Monetization Request has been approved!";
    const NOTIFICATION_RECEIVER = [submitData.employee.id];
    const NOTIFICATION_REDIRECT = "lmanagement";

    createNotification(
      NOTIFICATION_MESSAGE,
      NOTIFICATION_RECEIVER,
      NOTIFICATION_REDIRECT
    );
    // } else {
    //   dialog.close();
    //   this.showError("Insufficient Credits");
    // }
  }
}

export default MonetizationApproverFormPresenter;
